import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APP_CONFIG, AppConfig } from '@core/config';

@Injectable({ providedIn: 'root' })
export class InternalGateApiService {
  private readonly config: AppConfig = inject(APP_CONFIG);
  private readonly http = inject(HttpClient);

  login(username: string, password: string): Observable<void> {
    return this.http.post<void>(`${this.config.api.authUrl}/internal-gate/login`, { username, password }, { withCredentials: true });
  }

  verifySession(): Observable<void> {
    return this.http.post<void>(`${this.config.api.authUrl}/internal-gate/session/verify`, null, {
      withCredentials: true,
      headers: {
        Authorization: `Basic ${this.config.api.clientToken}`,
      },
    });
  }
}
